module.exports = __webpack_public_path__ + "img/modal-img.0d7635f0.png";